import ZohoCRM from "V2.0/HomePages/HomeIntegrations/ZohoCRM";
import { IntegrationShell } from "../common/Shell";
import { useOutletContext } from "react-router-dom";

export function ZohoCRMIntegration() {
    const { projectId, isViewOnly} = useOutletContext();

    return <IntegrationShell>
        <ZohoCRM projectId={projectId} isViewOnly={isViewOnly}/>
    </IntegrationShell>
}